import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query imageDeroulementquery {
        file(relativePath: { eq: "deroulement-consultation.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Déroulement d'une consultation de chirurgie orthopédique avec le Dr Philippe Roure dans son cabinet à Paris 7ème arrondissement"
        css={css`
          width: 100%;
          @media (max-width: 678px) {
            display: none;
          }
        `}
      />
    )}
  />
)
